export const TYPE_ERROR = 'error'
export const TYPE_WARNING = 'warning'
export const TYPE_INFO = 'info'

const TYPE_WARNING_RANGE = { start: 7000, end: 7999 }
const TYPE_INFO_RANGE = { start: 9000, end: 9999 }

const getErrorType = ({ errorCode }) => {
  const isWithinRange = range => errorCode >= range.start && errorCode <= range.end

  if (isWithinRange(TYPE_INFO_RANGE)) {
    return TYPE_INFO
  }

  if (isWithinRange(TYPE_WARNING_RANGE)) {
    return TYPE_WARNING
  }

  return TYPE_ERROR
}

export function groupErrorsByType(cellData) {
  const initialMemo = {
    [TYPE_ERROR]: [],
    [TYPE_WARNING]: [],
    [TYPE_INFO]: [],
  }

  if (!cellData || !cellData.errors) {
    return initialMemo
  }

  // group the errors by type
  return cellData.errors.reduce((memo, err) => {
    const type = getErrorType(err)
    memo[type].push(err)
    return memo
  }, initialMemo)
}
